import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatSnackBar, MatMenuTrigger, ErrorStateMatcher } from '@angular/material';
import { FormBuilder, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ClientService } from "../../services/client.service";
import { PolicyService } from '../../services/policy.service'
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { Observable } from 'rxjs';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
declare var $;


export interface Client {
  _id: string;
  name: string;
  email: string;
};

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-add-client-modal',
  templateUrl: './add-client-modal.component.html',
  styleUrls: ['./add-client-modal.component.scss']
})
export class AddClientModalComponent implements OnInit {
  loading: Boolean = false;
  confirmPassword = new FormControl('');
  passwordMismatch: boolean;
  show: boolean;
  pwd: boolean;
  show1: boolean;
  pwd1: boolean;
  error: any;
  clientForm
  isEdit: boolean = false
  isClient: boolean = false
  isPolicy: boolean
  color
  rgba: any;
  always: any;
  matcher = new MyErrorStateMatcher();

  @ViewChild('clickMenuTrigger', { static: false })
  private readonly clickMenuTrigger: MatMenuTrigger;

  ngOnInit() {
    // console.log("is client model call or not ")
    this.confirmPassword.setErrors({ nomatch: true });

    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });
    console.log("data in add client model ", this.data)
    if (this.data && this.data.isClient) this.isClient = true
    else this.isClient = false
    if (this.data && this.data.isEdit) this.isEdit = true
    else this.isEdit = false
    // let size = Object.keys(this.data).length;
    // if (size != 0 && !this.data.isClient) {
    //   if (this.data && this.data.password) this.data.password = this._EncryptDecryptService.decrypt(this.data.password)
    //   if (this.data && this.data.confirmPassword) this.data.confirmPassword = this.data.password;
    //   if (this.data && this.data.userId) this.isPolicy = this.data.userId.passwordPolicy
    //   console.log("Hello Edit Client data ", this.data)
    //   this.isEdit = true
    // } else {
    //   console.log("Hello Add Client DAta", this.data)
    //   this.isEdit = false
    // }
    this.createForm(this.data)
  }
  constructor(public _EncryptDecryptService: EncryptDecryptService, public dialog: MatDialog, public _policyService: PolicyService, public _snackBar: MatSnackBar, public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, public _clientService: ClientService, private formBuilder: FormBuilder) {
    // NO DEFINITION
  }


  //create Form 
  createForm(editData?) {
    this.clientForm = this.formBuilder.group({
      name: new FormControl((editData && editData.name) ? editData.name : '', Validators.required),
      email: new FormControl((editData && editData.email) ? editData.email : '', Validators.required),
      password: new FormControl((editData && editData.password) ? this._EncryptDecryptService.decrypt(editData.password) : '', Validators.compose([
        Validators.required,
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(8)
      ])),
      confirmPassword: new FormControl((editData && editData.password) ? this._EncryptDecryptService.decrypt(editData.password) : '', Validators.required),
      isAllow: new FormControl((editData && editData.isAllow) ? editData.isAllow : false),
      color: new FormControl('')
    }, {
      validator: this._policyService.passwordMatchValidator
    })
  }


  validate(data) {
    console.log("Validating ", data);
    if (!data.name) return false;
    if (!data.email) return false;
    if (!data.password) return false;
    if (!data.confirmPassword) return false;
    if (data.password !== data.confirmPassword) {
      this.passwordMismatch = true;
      return false;
    }
    this.passwordMismatch = false;
    return true;
  }

  doSubmit() {
    if (this.error) {
      this.error = ""
    }
    console.log("Submit ", this.data);
    // Do Submit
    this.loading = true;
    if (this.isEdit) {
      let cData = {
        name: this.clientForm.value.name,
        email: this.clientForm.value.email,
        password: this._EncryptDecryptService.encrypt(this.clientForm.value.password),
        isPolicy: this.isPolicy,
        confirmPassword: this._EncryptDecryptService.encrypt(this.clientForm.value.confirmPassword),
        _id: this.data._id,
      }
      console.log("this is the data of edit client", cData, this.isPolicy);
      this.loading = true;
      this._clientService.editClient(cData).subscribe(client => {
        // this.clientData = client;
        console.log("CLIENTDATA = ", client);
        this.loading = false;
        console.log('Dialog closed', client);
        this.closoeDialog({
          action: 'edit',
          result: 'success',
          data: client
        });
      }, err => {
        this.error = err.msg
        this.loading = false;
      });
    } else {

      let client = {
        name: this.clientForm.value.name,
        email: this.clientForm.value.email,
        password: this._EncryptDecryptService.encrypt(this.clientForm.value.password),
        confirmPassword: this._EncryptDecryptService.encrypt(this.clientForm.value.confirmPassword),
        isClient: this.data.isClient,
        isAllow: this.clientForm.value.isAllow,
        color: this.clientForm.value.color
      }
      if (this.data && this.data.masterClientId) client['masterClientId'] = this.data.masterClientId
      console.log('this.data========>', client);
      this._clientService.addClient(client).subscribe(data => {
        this.data = data;
        this.data['password'] = this._EncryptDecryptService.encrypt(this.data.password)
        this.loading = false;
        console.log("Added Successfully", data);
        this.dialogRef.close(data);

      }, err => {
        this.error = err.msg
        this.loading = false;
        // this.dialogRef.close(null);
      });
    }
  }


  delete() {
    console.warn("DELETING ", this.data._id);
    this.openDialog(DeleteConfirmModalComponent, "Client").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this.loading = true;
        this._clientService.deleteClient(this.data._id, true).subscribe(clients => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'success',
            data: this.data
          });
        }, err => {
          // alert("Course of any job can not be deleted!")
          if (err.msg == "Client Not Deleted") {
            this.error = "Client with jobs cannot be deleted"
          }
          // console.log("");
          this.loading = false;
        });
      }
    })
  }

  onKeyPress(x) {
    this.clickMenuTrigger.openMenu();
    this.isPolicy = true
    // console.log("value of password", this.passwords);
  }
  closeModel() {
    this.clickMenuTrigger.closeMenu();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }

  closoeDialog(result) {
    console.log('On no click here');
    this.dialogRef.close(result);
  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
